const PHOTOSWIPE_MODULE_URL = 'https://cdn.jsdelivr.net/npm/photoswipe@5/dist/photoswipe.esm.min.js';
const MOBILE_MEDIA_QUERY = '(max-width: 767.98px)';

let photoswipeModulePromise;

const loadPhotoSwipe = () => {
  photoswipeModulePromise = photoswipeModulePromise || import(PHOTOSWIPE_MODULE_URL);
  return photoswipeModulePromise;
};

const leftIcon = `
  <svg aria-hidden="true" focusable="false" fill="none" width="16" class="icon icon--direction-aware" viewBox="0 0 16 18">
    <path d="M11 1 3 9l8 8" stroke="currentColor" stroke-linecap="square"></path>
  </svg>
`;

const rightIcon = `
  <svg aria-hidden="true" focusable="false" fill="none" width="16" class="icon icon--direction-aware" viewBox="0 0 16 18">
    <path d="m5 17 8-8-8-8" stroke="currentColor" stroke-linecap="square"></path>
  </svg>
`;

const closeIcon = `
  <svg aria-hidden="true" focusable="false" fill="none" width="16" class="icon" viewBox="0 0 16 16">
    <path d="m1 1 14 14M1 15 15 1" stroke="currentColor" stroke-width="1"></path>
  </svg>
`;

const isMobileViewport = () => window.matchMedia(MOBILE_MEDIA_QUERY).matches;

const getGalleryItems = (gallery) =>
  Array.from(gallery.querySelectorAll('.product__slide:not(.swiper-slide-duplicate) .product__zoom-link')).map(
    (link) => ({
      src: link.href,
      width: Number(link.dataset.pswpWidth),
      height: Number(link.dataset.pswpHeight),
      alt: link.querySelector('img')?.alt || '',
    })
  );

const initProductGalleryZoom = () => {
  document.querySelectorAll('[data-qbs-photoswipe-gallery]').forEach((gallery) => {
    if (gallery.dataset.qbsPhotoswipeInitialized === 'true') return;
    gallery.dataset.qbsPhotoswipeInitialized = 'true';

    gallery.addEventListener('click', async (event) => {
      const link = event.target.closest('.product__zoom-link');
      if (!link || !gallery.contains(link)) return;

      event.preventDefault();
      if (!isMobileViewport()) return;

      const items = getGalleryItems(gallery).filter((item) => item.src && item.width && item.height);
      const index = Math.max(0, Number(link.dataset.qbsGalleryIndex) || 0);
      if (!items.length) return;

      const { default: PhotoSwipe } = await loadPhotoSwipe();
      const labels = {
        previous: gallery.dataset.qbsPhotoswipePrevLabel || 'Previous image',
        next: gallery.dataset.qbsPhotoswipeNextLabel || 'Next image',
        close: gallery.dataset.qbsPhotoswipeCloseLabel || 'Close gallery',
      };
      const photoSwipe = new PhotoSwipe({
        dataSource: items,
        index: Math.min(index, items.length - 1),
        bgOpacity: 1,
        showHideAnimationType: 'none',
        showAnimationDuration: 0,
        hideAnimationDuration: 0,
        zoomAnimationDuration: 0,
        arrowPrev: false,
        arrowNext: false,
        close: false,
        counter: false,
        zoom: false,
      });

      photoSwipe.on('afterInit', () => {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            photoSwipe.element?.classList.add('qbs-pswp--controls-ready');
          });
        });
      });

      photoSwipe.on('close', () => {
        photoSwipe.element?.classList.remove('qbs-pswp--controls-ready');
      });

      photoSwipe.on('uiRegister', () => {
        photoSwipe.ui.registerElement({
          name: 'qbsPrev',
          ariaLabel: labels.previous,
          order: 8,
          isButton: true,
          html: leftIcon,
          onClick: () => photoSwipe.prev(),
          onInit: (element) => {
            element.classList.add('circle-button');
          },
        });

        photoSwipe.ui.registerElement({
          name: 'qbsClose',
          ariaLabel: labels.close,
          order: 9,
          isButton: true,
          html: closeIcon,
          onClick: () => photoSwipe.close(),
          onInit: (element) => {
            element.classList.add('circle-button', 'circle-button--xl');
          },
        });

        photoSwipe.ui.registerElement({
          name: 'qbsNext',
          ariaLabel: labels.next,
          order: 10,
          isButton: true,
          html: rightIcon,
          onClick: () => photoSwipe.next(),
          onInit: (element) => {
            element.classList.add('circle-button');
          },
        });
      });

      photoSwipe.init();
    });
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initProductGalleryZoom, { once: true });
} else {
  initProductGalleryZoom();
}

document.addEventListener('shopify:section:load', initProductGalleryZoom);
